"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.minBigInt = exports.maxBigInt = exports.floor = exports.ceil = exports.round = void 0;
const round = (value) => value >= 0 ? Math.round(value) : -Math.round(-value);
exports.round = round;
const ceil = (value) => (value >= 0 ? Math.ceil(value) : Math.floor(value));
exports.ceil = ceil;
const floor = (value) => (value >= 0 ? Math.floor(value) : Math.ceil(value));
exports.floor = floor;
const maxBigInt = (...values) => {
    if (values.length === 0 || !values[0]) {
        throw new Error("No values provided.");
    }
    let max = values[0];
    for (const current of values) {
        if (current > max) {
            max = current;
        }
    }
    return max;
};
exports.maxBigInt = maxBigInt;
const minBigInt = (...values) => {
    if (values.length === 0 || !values[0]) {
        throw new Error("No values provided.");
    }
    let min = values[0];
    for (const current of values) {
        if (current < min) {
            min = current;
        }
    }
    return min;
};
exports.minBigInt = minBigInt;
//# sourceMappingURL=math.js.map